import axios from 'axios';
import router from '@/router'; // Make sure this path is correct for your project

// Helper function to get base URL and token
const getApiConfig = () => {
  const userToken = localStorage.getItem('userToken');
  const baseURL = process.env.VUE_APP_API_URL || 'http://127.0.0.1:3000/api';
  return { userToken, baseURL };
};

const state = {
  files: {
    laserftp: [],
    csvfiles: [],
    logos: [],
  },
  isLoading: false,
  error: null,
};

const mutations = {
  SET_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_FILES(state, { category, files }) {
    if (state.files.hasOwnProperty(category)) {
      state.files[category] = files;
    }
  },
};

const actions = {
  async fetchFiles({ commit }, category) {
    const { baseURL, userToken } = getApiConfig();
    if (!userToken) {
      commit('SET_ERROR', 'User not authenticated.');
      router.push({ name: 'login' });
      return;
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);

    try {
      // Calling 'file-lists' endpoint with category as query parameter
      const response = await axios.get(`${baseURL}/file-lists`, {
        params: { 
          category: category 
        },
        
        headers: { Authorization: `Bearer ${userToken}` },
      });
      
      commit('SET_FILES', { category, files: response.data });
    } catch (error) {
      console.error(`Error fetching file list for ${category}:`, error);
      commit('SET_ERROR', error.response?.data?.details || error.message);
      throw error; // Re-throw for the component to catch
    } finally {
      commit('SET_LOADING', false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};

